import apiConfig from "../../../config/api";
import trace from "../../../helpers/trace";
import store from "../../../config/store";
import { ErrorSnacktOpen } from "../../ErrorSnack/actions";
const download = require("downloadjs");

export const OpenModalVerDetalle = (modalVerDetalle, idSolicitud) => ({
  type: "GRILLA_SOLICITUDES/OPEN_MODAL_VER_DETALLE",
  modalVerDetalle,
  idSolicitud,
});

export const LoadingFile = loadingFile => ({
  type: "GRILLA_SOLICITUDES/LOADINGFILE",
  loadingFile
})

// ////////////////////////
// Action Orchestrators  //
// ////////////////////////

export const GetComprobanteSolicitud = (idSolicitud, tipoSolicitud) => (dispatch) => {
  const globalState = store.getState().global;

  const params = {
    IdSolicitud: idSolicitud,
    token: globalState.token,
  };

  let urlMethod = `${apiConfig.apiUri}/v1/solicitudes/ComprobantePdf`;
  if (tipoSolicitud === 12) {
    urlMethod = `${apiConfig.apiUri}/v1/solicitudes/ComprobanteReajustePdf`;
  }
  if (tipoSolicitud === 71) {
    urlMethod = `${apiConfig.apiUri}/v1/paquetes/ComprobantePdf`;
  }
  if (tipoSolicitud === 69) {
    urlMethod = `${apiConfig.apiUri}/v1/paquetes/ComprobanteReajustePdf`;
  }
  fetch(urlMethod, {
    method: "POST",
    headers: {
      // "Content-Type": "application/json",
      // Authorization: localStorage.getItem('id_token'),
    },
    credentials: "same-origin",
    body: JSON.stringify(params),
  })
    .then((response) => {
      if (!response.ok) { throw response; }
      return response.blob();
    })
    .then((blob) => {
      dispatch(LoadingFile(false))
      download(blob, `Comprobante_${idSolicitud}.pdf`, "application/pdf");
    })
    .catch((error) => {
      dispatch(LoadingFile(false))
      trace.error("GetFileDetalleSolicitud", error);
      dispatch(ErrorSnacktOpen(
        "Error al descargar el comprobante de la solicitud:",
        error,
      ));
    });
};

export const GetFileDetalleSolicitudExcel = (idSolicitud) => (dispatch) => {
  const globalState = store.getState().global;

  const params = {
    RutInstitucion: globalState.rutInstitucion,
    Isapre: globalState.isapre,
    IdSolicitud: idSolicitud,
    token: globalState.token,
  };

  fetch(`${apiConfig.apiUri}/v1/solicitudes/DetalleSolicitudFile`, {
    method: "POST",
    headers: {
      // "Content-Type": "application/json",
      // Authorization: localStorage.getItem('id_token'),
    },
    credentials: "same-origin",
    body: JSON.stringify(params),
  })
    .then((response) => {
      if (!response.ok) { throw response; }
      return response.blob();
    })
    .then((blob) => {
      download(blob, `DetalleSolicitud_${idSolicitud}.xlsx`, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet");
    })
    .catch((error) => {
      trace.error("GetFileDetalleSolicitud", error);
      dispatch(ErrorSnacktOpen(
        "Error al descargar el detalle de la solicitud Excel:",
        error,
      ));
    });
};

export const getDetalleSolBOConvnioReajusteExcel = (idSolicitud) => (dispatch) => {
  const globalState = store.getState().global;
  const params = {
    RutInstitucion: globalState.rutInstitucion,
    Isapre: globalState.isapre,
    IdSolicitud: idSolicitud,
    modulo: "web",
    token: globalState.token,
  };

  fetch(`${apiConfig.apiUri}/v1/solicitudes/getDetalleSolBOConvnioReajusteExcel`, {
    method: "POST",
    headers: {
      // "Content-Type": "application/json",
      // Authorization: localStorage.getItem('id_token'),
    },
    credentials: "same-origin",
    body: JSON.stringify(params),
  })
    .then((response) => {
      if (!response.ok) { throw response; }
      return response.blob();
    })
    .then((blob) => {
      download(blob, `DetalleSolicitud_${idSolicitud}.xlsx`, "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet");
    })
    .catch((error) => {
      trace.error("GetFileDetalleSolicitud", error);
      dispatch(ErrorSnacktOpen(
        "Error al descargar el detalle de la solicitud de reajuste Excel:",
        error,
      ));
    });
};